import { FC } from "react";
import styled from "@emotion/styled";
import { SpaceAccountTopicObservable } from "@/store/topics/SpaceAccountTopicObservable";
import { useAppStore } from "@/store";
import { MDSText, MDSTextVariant } from "@/mds";
import { useThemedCollectionColors } from "@/mds/themes/useThemedCollectionColors";

interface TopicChipProps {
  topic: SpaceAccountTopicObservable;
}

export const TopicChip: FC<TopicChipProps> = ({ topic }) => {
  const { store } = useAppStore();
  const { bgColor, textColor } = useThemedCollectionColors(topic.id);

  return (
    <ChipWrapper
      style={{ backgroundColor: bgColor, color: textColor }}
      onClick={() => store.navigation.goToExploreTopicDetail({ topicId: topic.id })}
    >
      <MDSText variant={MDSTextVariant.TextS}>{topic.title}</MDSText>
    </ChipWrapper>
  );
};

const ChipWrapper = styled.div({
  padding: "8px 16px",
  borderRadius: "16px",
  cursor: "pointer",
  transition: "transform 0.2s",
  "&:hover": {
    transform: "scale(1.05)",
  },
});
